import React, { useMemo } from 'react'

import { Select } from 'antd'

import './Styles.css'

const CustomSelect = ({ icon, value, label, placeholder, options = [], onChange = () => ({}) }) => {
  const buildOptions = useMemo(
    () =>
      options.map((option) => (
        <Select.Option className="option" value={option.id} key={option.id}>
          {option.description}
        </Select.Option>
      )),
    [options]
  )

  return (
    <div className="custom-select">
      {icon && <img src={icon} alt="select-icon" />}

      <div className="form-control">
        <label className="label">{label}</label>
        <Select showSearch className="select" placeholder={placeholder} onChange={onChange} value={value}>
          {buildOptions}
        </Select>
      </div>
    </div>
  )
}

export default CustomSelect
